(function () {
  'use strict';

  var inDesignMode = window.Shopify && window.Shopify.designMode;
  document.documentElement.classList.toggle('shopify-design-mode', !!inDesignMode);

  var root = document.querySelector('.bogo');
  if (!root) return;

  var CFG = window.BOGO_CONFIG || {};
  var DISCOUNT_CODE = CFG.discountCode || 'RANGERBOGO50';
  var SHIPPING_CODE = CFG.shippingCode || '';
  var LANDING_PAGE = CFG.landingPage || 'bogo-50-off-v2-rangers';
  var PRODUCT = window.BOGO_PRODUCT || null;

  /* ---------------- UTM capture ---------------- */
  function captureUTMs() {
    var params = new URLSearchParams(window.location.search);
    var utms = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'landing_page'].forEach(function (k) {
      var v = params.get(k);
      if (v) utms[k] = v;
    });
    utms['landing_page'] = utms['landing_page'] || LANDING_PAGE;
    try { sessionStorage.setItem('bogo_utms', JSON.stringify(utms)); } catch (e) {}
  }
  captureUTMs();
  function getUTMs() {
    try { return JSON.parse(sessionStorage.getItem('bogo_utms') || '{}'); } catch (e) { return {}; }
  }

  /* ---------------- Countdown timer ---------------- */
  (function initCountdown() {
    var el = root.querySelector('[data-countdown]');
    if (!el) return;
    var endRaw = el.getAttribute('data-end');
    var end = new Date(endRaw).getTime();
    if (isNaN(end)) { el.style.display = 'none'; return; } // bad date -> hide rather than show NaN
    var dEl = el.querySelector('[data-cd-days]');
    var hEl = el.querySelector('[data-cd-hours]');
    var mEl = el.querySelector('[data-cd-mins]');
    var sEl = el.querySelector('[data-cd-secs]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        // Freeze at zero, leave the page fully live and shoppable.
        dEl.textContent = '00'; hEl.textContent = '00'; mEl.textContent = '00'; sEl.textContent = '00';
        el.classList.add('is-ended');
        return; // stop ticking
      }
      var s = Math.floor(diff / 1000);
      dEl.textContent = pad(Math.floor(s / 86400));
      hEl.textContent = pad(Math.floor((s % 86400) / 3600));
      mEl.textContent = pad(Math.floor((s % 3600) / 60));
      sEl.textContent = pad(s % 60);
      requestAnimationFrame(function () { setTimeout(tick, 1000); });
    }
    tick();
  })();

  /* ---------------- Klaviyo: Viewed Product ---------------- */
  (function fireViewed() {
    if (!PRODUCT) return;
    var item = {
      Name: PRODUCT.title,
      ProductID: PRODUCT.id,
      Categories: ['Backpacks'],
      ImageURL: PRODUCT.featured_image,
      URL: PRODUCT.url,
      Brand: 'FORWRD',
      Price: (PRODUCT.price / 100).toFixed(2),
      Offer: 'BOGO 50% Off'
    };
    var tryFire = function () {
      if (window._learnq) {
        window._learnq.push(['track', 'Viewed Product', item]);
        window._learnq.push(['trackViewedItem', { Title: item.Name, ItemId: item.ProductID, ImageUrl: item.ImageURL, Url: item.URL, Metadata: { Brand: 'FORWRD', Price: item.Price, Offer: 'BOGO' } }]);
      } else {
        setTimeout(tryFire, 400);
      }
    };
    tryFire();
  })();

  /* ---------------- Dual color picker ---------------- */
  // Each .bogo-pick holds one bag's selection. Track variant + name per pick.
  var picks = {};
  function initPick(pickEl) {
    var slot = pickEl.getAttribute('data-slot'); // 'you' | 'them'
    var swatches = pickEl.querySelectorAll('.bogo-swatch');
    var previewImg = pickEl.querySelector('.bogo-pick__preview img');
    var boBadge = pickEl.querySelector('.bogo-pick__bo');
    var promptEl = pickEl.querySelector('.bogo-pick__prompt');
    var chosenEl = pickEl.querySelector('.bogo-pick__chosen');
    var clabel = pickEl.querySelector('.bogo-pick__chosen strong');

    picks[slot] = { variantId: null, colorName: null, available: true };

    function select(sw, userInitiated) {
      if (sw.hasAttribute('disabled')) return;
      swatches.forEach(function (s) { s.classList.remove('is-active'); s.setAttribute('aria-checked', 'false'); });
      sw.classList.add('is-active');
      sw.setAttribute('aria-checked', 'true');
      picks[slot].variantId = sw.getAttribute('data-variant-id');
      picks[slot].colorName = sw.getAttribute('data-color-name');
      var img = sw.getAttribute('data-img');
      var isBackorder = sw.getAttribute('data-backorder') === 'true';
      var boText = sw.getAttribute('data-backorder-text') || '';
      if (img && previewImg) {
        previewImg.style.opacity = '0';
        var pre = new Image();
        pre.onload = function () { previewImg.src = img; previewImg.style.opacity = '1'; };
        pre.onerror = function () { previewImg.style.opacity = '1'; };
        pre.src = img;
      }
      if (clabel) clabel.textContent = sw.getAttribute('data-color-name');
      // Only swap the instruction for the chosen-color label once the user actively picks,
      // so the "tap a color" cue stays visible on load even though a default is pre-selected.
      if (userInitiated) {
        if (promptEl) promptEl.hidden = true;
        if (chosenEl) chosenEl.hidden = false;
      }
      if (boBadge) {
        if (isBackorder && boText) { boBadge.textContent = boText; boBadge.classList.add('is-on'); }
        else { boBadge.classList.remove('is-on'); }
      }
      updateSummary();
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () { select(sw, true); });
      sw.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(sw, true); }
      });
    });

    // Default to the first available swatch (bestseller is ordered first in Liquid).
    // Pass userInitiated=false so the instruction prompt stays visible until they choose.
    var firstAvail = Array.prototype.find.call(swatches, function (s) { return !s.hasAttribute('disabled'); });
    if (firstAvail) select(firstAvail, false);
  }
  document.querySelectorAll('.bogo-pick').forEach(initPick);

  /* ---------------- Pricing summary ---------------- */
  // Anchored on regular unit price passed from Liquid (in cents).
  var UNIT = CFG.unitPrice || (PRODUCT ? PRODUCT.price : 19500); // cents
  function money(cents) {
    var dollars = cents / 100;
    // whole-dollar if .00, else 2dp
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }
  function updateSummary() {
    var two = UNIT * 2;
    var pay = Math.round(UNIT + UNIT * 0.5); // second at 50% off
    var saved = two - pay;
    var perBag = pay / 2;
    var nowEl = root.querySelector('[data-sum-now]');
    var wasEl = root.querySelector('[data-sum-was]');
    var saveEl = root.querySelector('[data-sum-save]');
    var perEl = root.querySelectorAll('[data-sum-perbag]');
    if (nowEl) nowEl.textContent = money(pay);
    if (wasEl) wasEl.textContent = money(two);
    if (saveEl) saveEl.textContent = 'Save ' + money(saved);
    perEl.forEach(function (el) { el.textContent = money(Math.round(perBag)); });
    // sticky
    var sNow = root.querySelector('[data-sticky-now]');
    var sWas = root.querySelector('[data-sticky-was]');
    if (sNow) sNow.textContent = money(pay);
    if (sWas) sWas.textContent = money(two);
  }
  updateSummary();

  /* ---------------- Name-tag add-on (1 or 2 tags, full fields) ---------------- */
  // getAddonItems(baseProps) returns an array of line items (0, 1, or 2),
  // or the string 'invalid' if a checked tag is missing required info.
  var addonEl = root.querySelector('[data-addon]');
  var addonVariants = [];
  // per-tag selected-option arrays, keyed by tag number
  var addonTagState = {};
  var addonImages = {};
  function initAddon() {
    if (!addonEl) return;
    var raw = addonEl.querySelector('[data-addon-variants]');
    try { addonVariants = raw ? JSON.parse(raw.textContent) : []; } catch (e) { addonVariants = []; }
    var rawImg = addonEl.querySelector('[data-addon-images]');
    try { addonImages = rawImg ? JSON.parse(rawImg.textContent) : {}; } catch (e) { addonImages = {}; }
    var seed = addonVariants.find(function (v) { return v.available; }) || addonVariants[0];
    var seedOpts = seed && seed.options ? seed.options.slice() : [];

    // main checkbox shows/hides the whole config
    var check = addonEl.querySelector('[data-addon-check]');
    var config = addonEl.querySelector('[data-addon-config]');
    if (check && config) {
      check.addEventListener('change', function () {
        config.hidden = !check.checked;
        addonEl.classList.toggle('is-on', check.checked);
        hideAddonErrors();
      });
    }

    // "Add a 2nd tag" toggle
    var secondCheck = addonEl.querySelector('[data-addon-second-check]');
    var tag2 = addonEl.querySelector('[data-addon-tag="2"]');
    if (secondCheck && tag2) {
      secondCheck.addEventListener('change', function () {
        tag2.hidden = !secondCheck.checked;
        hideAddonErrors();
      });
    }

    // init each tag block independently
    addonEl.querySelectorAll('[data-addon-tag]').forEach(function (tagEl) {
      var n = tagEl.getAttribute('data-addon-tag');
      addonTagState[n] = { selected: seedOpts.slice(), variantId: (seed && seed.id) || null, el: tagEl };
      tagEl.querySelectorAll('.bogo-addon__opt-val').forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Read the option slot from the parent .bogo-addon__opt wrapper, which carries
          // the correct option index (the button's own attr can collide with value index).
          var optGroup = btn.closest('.bogo-addon__opt');
          var idx = parseInt(optGroup.getAttribute('data-addon-opt-index'), 10);
          addonTagState[n].selected[idx] = btn.getAttribute('data-addon-opt-value');
          refreshTagOptions(n, idx);
        });
      });
      // clear error as user types/picks
      tagEl.querySelectorAll('[data-addon-name], input[type="radio"]').forEach(function (el) {
        el.addEventListener('input', hideAddonErrors);
        el.addEventListener('change', hideAddonErrors);
      });
      refreshTagOptions(n);
    });
  }
  // Is a given option-value compatible with the rest of the current selection?
  function valueAvailable(optIndex, value, sel) {
    return addonVariants.some(function (v) {
      if (!v.options) return false;
      if (v.options[optIndex] !== value) return false;
      return v.options.every(function (opt, i) { return i === optIndex ? true : opt === sel[i]; });
    });
  }
  function firstAvailableValue(optIndex, sel) {
    var found = null;
    addonVariants.some(function (v) {
      if (!v.options) return false;
      var ok = v.options.every(function (opt, i) { return i === optIndex ? true : opt === sel[i]; });
      if (ok) { found = v.options[optIndex]; return true; }
      return false;
    });
    return found;
  }
  // changedIdx = the option the user just clicked (keep it fixed; snap the others if needed)
  function refreshTagOptions(n, changedIdx) {
    var st = addonTagState[n];
    if (!st || !addonVariants.length) return;
    var tagEl = st.el;
    var sel = st.selected;
    // If the full combo doesn't exist, keep the option the user just changed and
    // snap the OTHER option(s) to a value that forms a real variant (e.g. Paddle has
    // fewer colors, so switching to Paddle nudges the color to an available one).
    var exists = addonVariants.some(function (v) {
      return (v.options || []).every(function (opt, i) { return opt === sel[i]; });
    });
    if (!exists) {
      tagEl.querySelectorAll('.bogo-addon__opt').forEach(function (optGroup) {
        var idx = parseInt(optGroup.getAttribute('data-addon-opt-index'), 10);
        if (idx === changedIdx) return; // don't override the user's deliberate pick
        var fb = firstAvailableValue(idx, sel);
        if (fb) sel[idx] = fb;
      });
    }
    // Paint selected + availability state. A value is "available" if choosing it
    // (while holding the other currently-selected options fixed) forms a real variant.
    // e.g. with Paddle selected, only Black/Orange/Blue stay enabled; the rest gray out.
    tagEl.querySelectorAll('.bogo-addon__opt').forEach(function (optGroup) {
      var idx = parseInt(optGroup.getAttribute('data-addon-opt-index'), 10);
      optGroup.querySelectorAll('.bogo-addon__opt-val').forEach(function (btn) {
        var val = btn.getAttribute('data-addon-opt-value');
        btn.classList.toggle('is-on', val === sel[idx]);
        var available = addonVariants.some(function (v) {
          if (!v.options) return false;
          return v.options.every(function (opt, i) { return i === idx ? opt === val : opt === sel[i]; });
        });
        btn.classList.toggle('is-disabled', !available);
        btn.disabled = !available;
        btn.setAttribute('aria-disabled', available ? 'false' : 'true');
      });
    });
    resolveTagVariant(n);
    updateTagPreview(n);
  }
  function resolveTagVariant(n) {
    if (!addonVariants.length || !addonTagState[n]) return;
    var sel = addonTagState[n].selected;
    var match = addonVariants.find(function (v) {
      return (v.options || []).every(function (opt, i) { return opt === sel[i]; });
    });
    if (match) addonTagState[n].variantId = match.id;
  }
  function updateTagPreview(n) {
    var st = addonTagState[n];
    if (!st || !st.el) return;
    var img = st.el.querySelector('[data-addon-preview]');
    if (img && st.variantId && addonImages[st.variantId]) {
      img.src = addonImages[st.variantId];
    }
  }
  function hideAddonErrors() {
    if (!addonEl) return;
    addonEl.querySelectorAll('[data-addon-err]').forEach(function (e) { e.hidden = true; });
  }
  function buildTagItem(tagEl, n, baseProps) {
    var nameInput = tagEl.querySelector('[data-addon-name]');
    var contactInput = tagEl.querySelector('[data-addon-contact]');
    var extraInput = tagEl.querySelector('[data-addon-extra]');
    var logoChecked = tagEl.querySelector('input[type="radio"]:checked');
    var name = nameInput ? nameInput.value.trim() : '';
    // required: name + logo choice
    if (!name || !logoChecked) {
      var err = tagEl.querySelector('[data-addon-err]');
      if (err) err.hidden = false;
      if (!name && nameInput) nameInput.focus();
      return 'invalid';
    }
    // Engraving properties ONLY — keys/values match the Magical Form Fields product
    // page exactly so the fulfillment system reads these tags identically. No UTM noise.
    var props = {};
    props['Name'] = name;
    if (contactInput && contactInput.value.trim()) props['Contact Info'] = contactInput.value.trim();
    if (extraInput && extraInput.value.trim()) props['Anything Else'] = extraInput.value.trim();
    props['Include FORWRD logo on my tag'] = logoChecked.value;
    return { id: parseInt(addonTagState[n].variantId, 10), quantity: 1, properties: props };
  }
  function getAddonItems(baseProps) {
    if (!addonEl) return [];
    var check = addonEl.querySelector('[data-addon-check]');
    if (!check || !check.checked) return [];
    var items = [];
    // tag 1 (always part of the order when add-on is checked)
    var tag1El = addonEl.querySelector('[data-addon-tag="1"]');
    var item1 = buildTagItem(tag1El, '1', baseProps);
    if (item1 === 'invalid') return 'invalid';
    items.push(item1);
    // tag 2 (only if the 2nd-tag toggle is on)
    var secondCheck = addonEl.querySelector('[data-addon-second-check]');
    if (secondCheck && secondCheck.checked) {
      var tag2El = addonEl.querySelector('[data-addon-tag="2"]');
      var item2 = buildTagItem(tag2El, '2', baseProps);
      if (item2 === 'invalid') return 'invalid';
      items.push(item2);
    }
    return items;
  }
  initAddon();

  /* ---------------- Accessories row (towel / clip / grips) ---------------- */
  // getAccessoryItems(baseProps) returns an array of selected accessory line items.
  // The whole card is clickable to add (qty 1). Once added, an inline stepper lets the
  // shopper raise/lower quantity; dropping to 0 removes the item and resets the card.
  var accCards = Array.prototype.slice.call(document.querySelectorAll('[data-acc]'));
  var accState = {}; // keyed by card index
  function renderAccCard(i) {
    var st = accState[i];
    if (!st) return;
    var card = st.card;
    var on = st.qty > 0;
    card.classList.toggle('is-on', on);
    card.setAttribute('aria-pressed', on ? 'true' : 'false');
    var addEl = card.querySelector('[data-acc-add]');
    var qtyEl = card.querySelector('[data-acc-qty]');
    var numEl = card.querySelector('[data-acc-qty-num]');
    if (addEl) addEl.hidden = on;
    if (qtyEl) qtyEl.hidden = !on;
    if (numEl) numEl.textContent = String(st.qty);
  }
  function accAdd(i) {
    var st = accState[i];
    if (!st) return;
    if (st.qty < 1) st.qty = 1;
    renderAccCard(i);
  }
  function accInc(i) {
    var st = accState[i];
    if (!st) return;
    st.qty = Math.min(st.qty + 1, 99);
    renderAccCard(i);
  }
  function accDec(i) {
    var st = accState[i];
    if (!st) return;
    st.qty = Math.max(st.qty - 1, 0);
    renderAccCard(i);
  }
  function initAccessories() {
    accCards.forEach(function (card, i) {
      var raw = card.querySelector('[data-acc-variants]');
      var variants = [];
      try { variants = raw ? JSON.parse(raw.textContent) : []; } catch (e) { variants = []; }
      // One-click add: use the first available variant (or first variant as fallback).
      var seed = variants.find(function (v) { return v.available; }) || variants[0];
      accState[i] = {
        variantId: (seed && seed.id) || parseInt(card.getAttribute('data-acc-variant'), 10),
        qty: 0,
        card: card
      };
      // Whole-card click toggles the item on (adds qty 1). Clicking again when already
      // on does nothing here (use the stepper to change qty or remove).
      card.addEventListener('click', function () {
        if (accState[i].qty < 1) accAdd(i);
      });
      // Keyboard support (card is role="button").
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (accState[i].qty < 1) accAdd(i);
        }
      });
      // Stepper controls. Stop propagation so they don't re-trigger the card click.
      var dec = card.querySelector('[data-acc-dec]');
      var inc = card.querySelector('[data-acc-inc]');
      if (dec) dec.addEventListener('click', function (e) { e.stopPropagation(); accDec(i); });
      if (inc) inc.addEventListener('click', function (e) { e.stopPropagation(); accInc(i); });
      renderAccCard(i);
    });
  }
  function getAccessoryItems(baseProps) {
    var items = [];
    accCards.forEach(function (card, i) {
      var st = accState[i];
      if (st && st.qty > 0 && st.variantId) {
        items.push({ id: parseInt(st.variantId, 10), quantity: st.qty, properties: assign({}, baseProps, { '__addon': 'accessory' }) });
      }
    });
    return items;
  }
  initAccessories();

  /* ---------------- Add-to-cart (BOGO: 2 items) ---------------- */
  var isAdding = false;
  function addPair(buttonEl) {
    if (isAdding) return;
    var you = picks['you'], them = picks['them'];
    if (!you || !you.variantId || !them || !them.variantId) {
      shake(buttonEl);
      return;
    }
    isAdding = true;
    var textEl = buttonEl.querySelector('.bogo-cta__text') || buttonEl;
    var original = textEl.textContent;
    buttonEl.setAttribute('disabled', 'true');
    textEl.textContent = 'ADDING YOUR PAIR…';

    var utms = getUTMs();
    var props = {};
    Object.keys(utms).forEach(function (k) { props['__' + k] = utms[k]; });
    props['__offer'] = 'BOGO 50% Off';

    var items = [
      { id: parseInt(you.variantId, 10), quantity: 1, properties: assign({}, props, { '__bag_for': 'You' }) },
      { id: parseInt(them.variantId, 10), quantity: 1, properties: assign({}, props, { '__bag_for': 'Gift' }) }
    ];

    // Optional name-tag add-on (1 or 2 tags). If a checked tag is missing its
    // required name/logo, stop and surface the inline error instead of adding a blank tag.
    var addonItems = getAddonItems(props);
    if (addonItems === 'invalid') {
      isAdding = false;
      buttonEl.removeAttribute('disabled');
      textEl.textContent = original;
      if (addonEl) addonEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    addonItems.forEach(function (it) { items.push(it); });

    // Optional accessories (towel / clip / grips) — each is variant-only, no validation.
    getAccessoryItems(props).forEach(function (it) { items.push(it); });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status >= 400) throw new Error(data.description || 'Could not add to cart');
        // Write cart-level attributes for attribution
        var attrPayload = { attributes: {} };
        Object.keys(utms).forEach(function (k) { attrPayload.attributes[k] = utms[k]; });
        attrPayload.attributes['landing_page'] = LANDING_PAGE;
        attrPayload.attributes['offer'] = 'BOGO 50% Off';
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(attrPayload),
          credentials: 'same-origin'
        });
      })
      .then(function () {
        // Apply the BOGO discount code so it carries through to checkout.
        // Primary method: hit /discount/CODE which sets the discount cookie.
        var codes = [DISCOUNT_CODE];
        if (SHIPPING_CODE) codes.push(SHIPPING_CODE);
        var codePath = codes.map(function (c) { return encodeURIComponent(c); }).join(',');
        return fetch('/discount/' + codePath, { method: 'GET', credentials: 'same-origin' })
          .catch(function () { /* non-fatal: the checkout ?discount= param below is the fallback */ });
      })
      .then(function () {
        // Klaviyo: Added to Cart
        if (window._learnq && PRODUCT) {
          window._learnq.push(['track', 'Added to Cart', {
            $value: (Math.round(UNIT + UNIT * 0.5) / 100).toFixed(2),
            AddedItemProductName: PRODUCT.title,
            AddedItemProductID: PRODUCT.id,
            AddedItemImageURL: PRODUCT.featured_image,
            AddedItemURL: PRODUCT.url,
            ItemNames: [PRODUCT.title + ' (BOGO Pair)'],
            Offer: 'BOGO 50% Off',
            Colors: [you.colorName, them.colorName]
          }]);
        }
        // Belt-and-suspenders: also pass the code on the checkout URL so it applies
        // even if the discount cookie didn't stick. Both methods are safe together.
        var checkoutCodes = [DISCOUNT_CODE];
        if (SHIPPING_CODE) checkoutCodes.push(SHIPPING_CODE);
        var discountParam = encodeURIComponent(checkoutCodes.join(','));
        window.location.href = '/checkout?discount=' + discountParam;
      })
      .catch(function (err) {
        console.error('BOGO ATC error:', err);
        isAdding = false;
        buttonEl.removeAttribute('disabled');
        textEl.textContent = original;
        alert('Sorry — there was an issue starting your order. Please try again, or text us at 801-857-9090.');
      });
  }

  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var src = arguments[i];
      for (var k in src) { if (Object.prototype.hasOwnProperty.call(src, k)) target[k] = src[k]; }
    }
    return target;
  }

  function shake(el) {
    el.animate(
      [{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(0)' }],
      { duration: 320, easing: 'ease-in-out' }
    );
  }

  // Wire all ATC buttons (builder + final). Scroll-only buttons jump to the builder.
  document.querySelectorAll('.bogo-js-atc').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addPair(btn);
    });
  });
  document.querySelectorAll('.bogo-js-scroll').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.querySelector('.bogo-build') || document.querySelector('.bogo-builder');
      if (target) target.scrollIntoView({ behavior: inDesignMode ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ---------------- "Text a friend" share ---------------- */
  (function share() {
    var shareUrl = (CFG.shareUrl || window.location.href.split('?')[0]);
    var msg = (CFG.shareMessage || 'Found us a deal — buy one Court Ranger pickleball bag, get the second 50% off. Want in? ') + shareUrl;
    var smsLink = root.querySelector('.bogo-js-sms');
    if (smsLink) {
      // iOS uses & ; Android uses ? — &body works broadly enough; provide both via separator detection
      var sep = /(iphone|ipad|ipod|mac)/i.test(navigator.userAgent) ? '&' : '?';
      smsLink.setAttribute('href', 'sms:' + sep + 'body=' + encodeURIComponent(msg));
    }
    var copyBtn = root.querySelector('.bogo-js-copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var done = function () {
          var label = copyBtn.querySelector('.lbl') || copyBtn;
          var prev = label.textContent;
          label.textContent = 'Link copied!';
          setTimeout(function () { label.textContent = prev; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareUrl).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = shareUrl; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e2) {}
          document.body.removeChild(ta); done();
        }
      });
    }
  })();

  /* ---------------- FAQ accordion ---------------- */
  document.querySelectorAll('.bogo-faq__item').forEach(function (item) {
    var q = item.querySelector('.bogo-faq__q');
    var a = item.querySelector('.bogo-faq__a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = item.classList.contains('is-open');
      if (open) {
        a.style.maxHeight = null;
        item.classList.remove('is-open');
        q.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        a.style.maxHeight = a.scrollHeight + 'px';
        q.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------------- Sticky bar visibility ---------------- */
  var sticky = root.querySelector('.bogo-sticky');
  var anchor = root.querySelector('.bogo-builder');
  if (sticky && anchor && !inDesignMode) {
    var heroCta = root.querySelector('.bogo-hero .bogo-cta');
    // Single source of truth, evaluated on every scroll/resize (rAF-throttled).
    // Show the sticky once the user has scrolled past the hero CTA AND the builder
    // is no longer meaningfully on screen (so we never cover the real CTA).
    var stickyTick = false;
    function evalSticky() {
      stickyTick = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Past the hero CTA? (its bottom is above the top of the viewport)
      var pastHero = true;
      if (heroCta) {
        var hr = heroCta.getBoundingClientRect();
        pastHero = hr.bottom < 0;
      }
      // Is the builder on screen? Consider it "on screen" if any decent part is visible.
      var br = anchor.getBoundingClientRect();
      var builderVisible = br.top < vh * 0.85 && br.bottom > vh * 0.15;
      // Also hide once the page footer / very bottom is reached is unnecessary here.
      if (pastHero && !builderVisible) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }
    function onStickyScroll() {
      if (!stickyTick) { stickyTick = true; window.requestAnimationFrame(evalSticky); }
    }
    window.addEventListener('scroll', onStickyScroll, { passive: true });
    window.addEventListener('resize', onStickyScroll, { passive: true });
    evalSticky();
  }
  var stickyBtn = root.querySelector('.bogo-sticky__btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var sTarget = document.querySelector('.bogo-build') || anchor;
      if (sTarget) sTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------------- Fade-up reveal ---------------- */
  if ('IntersectionObserver' in window && !inDesignMode) {
    var fadeObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); fadeObs.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    root.querySelectorAll('.fade-up').forEach(function (el) { fadeObs.observe(el); });
  } else {
    root.querySelectorAll('.fade-up').forEach(function (el) { el.classList.add('is-in'); });
  }
})();
